<div class="row driver-filter align-content-end" *transloco="let t; prefix: 'compliance.library.assetPicker'">
  <div class="input-group justify-content-end">
    <span class="w-100 input-group-text bg-transparent border-1 border-left z-1 filter-container">
      <a class="nav-link dropdown-toggle py-1 flex-grow-1 text-start" href="#" role="button"
        data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="false" #dropdownTrigger>
        <i class="ph ph-funnel-simple"></i>
        <span class="text-dark px-2">{{ !isLoaded() ? t('loading') : labelTitle }}</span>
      </a>
      @if(selectedCount > 0) {
        <span class="bg-danger text-white py-1 px-2 rounded-2 text-xs">
          {{ selectedCount }}
        </span>
      }

      <ul class="dropdown-menu custom-dropdown border-0" #dropdown>
        @if(!isLoaded()) {
          <div class="d-flex justify-content-center">
            <span class="spinner-border"></span>
          </div>
        }

        @if(isLoaded()) {
          <div class="sticky-top bg-white p-2">
            <div class="input-group align-items-center">
              <div class="col-1 ps-2 d-flex justify-content-center align-items-center rounded-start-3 border-1 search-icon">
                <i class="ph ph-magnifying-glass"></i>
              </div>
              <div class="col-11">
                <input type="text" class="ps-3 rounded-end-3 border-1 search-input"
                  [placeholder]="t('searchAssets')" [(ngModel)]="searchTerm" (input)="searchAssets($event)" />
              </div>
            </div>
          </div>

          <div class="dropdown-scroll">
            <cdk-virtual-scroll-viewport itemSize="33" minBufferPx="400" maxBufferPx="1000" class="viewport">
              <li *cdkVirtualFor="let item of filteredTree; trackBy: trackByTreeItem" class="dropdown-item"
                [ngStyle]="{ '--level': item.hierarchyLevel }">
                <div class="list-container">
                  <label [ngStyle]="{ 'padding-left.px': item.hierarchyLevel * 32 }"
                    [ngClass]="{ 'parent-item': item.isParent }">
                    <input type="checkbox"
                      [checked]="isItemChecked(item)"
                      [disabled]="isItemDisabled(item)"
                      (click)="onCheckboxChange(item); $event.stopPropagation()" />
                    <span [ngStyle]="{ 'color': isItemDisabled(item) ? '#E6E6E6' : 'inherit' }">{{ item.name }}</span>
                  </label>

                  @if(item.type === 'account' && !searchTerm) {
                    <label>
                      <span class="account-count">({{ getTotalAssets(item) | number }})</span>
                      <span class="collapse-arrow" (click)="toggleCollapse(item); $event.stopPropagation()">
                        <i [ngClass]="item.collapsed ? 'ph ph-caret-down' : 'ph ph-caret-up'"></i>
                      </span>
                    </label>
                  }
                </div>
              </li>
            </cdk-virtual-scroll-viewport>
          </div>
        }
      </ul>
    </span>
  </div>
</div>